import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import FooterNote from "./components/Footer/FooterNote";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
// import News from "./pages/News/News";
import Projects from "./pages/Projects/Projects";
import InHouseExpertise from "./pages/InHouseExpertise/InHouseExpertise";
import GetInTouch from "./pages/GetInTouch/GetInTouch";
import Services from "./pages/Services/Services";
// import NewsDetails from "./pages/News/NewsDetails";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ReactGA from 'react-ga';

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize('G-H1789XZ7J2');
    ReactGA.pageview(window.location.pathname + window.location.search);  
  },[]);

  return (
    <div>
        <ScrollToTop />
        <Navbar />
        <Routes location={location} key={location}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/aboutus" element={<AboutUs />} />
          {/* <Route exact path="/articles" element={<News />} />
          <Route exact path="/article/:slug" element={<NewsDetails />} /> */}
          <Route exact path="/projects" element={<Projects />} />
          <Route exact path="/inhouseexpertise" element={<InHouseExpertise />} />
          <Route exact path="/getintouch" element={<GetInTouch />} />
          <Route exact path="/services" element={<Services />} />
        </Routes>
        <Footer />
        <FooterNote />
      </div>
  );
}

export default App;
